import { makeEditorModal } from '../Modal';
import { TinyMCE, Editor } from 'tinymce';
import { displayErrors, getData, getTaskId, insertToEditor, pointsValid, setWindowNode, toJsonHtml } from '../core/Utils';
import { FeatureClass } from '../core/FeatureClass';
import { inputTransformation } from '../save/Interface';
import { getModalInputId, insertData } from "../save/SaveUtils";


declare let tinymce:TinyMCE;


export function addInputField(editor:Editor){
    const config = {
        featureName: "input-field",
        editor: editor,
        id: "if",
        icon: "select-all",
        tooltip: 'Eingabefeld',
        menuItems: [{
            name: 'edit-if',
            icon: 'edit-block',
            text: 'Bearbeiten',
            action: (editor:Editor, command:string) => {
                const node = setWindowNode(editor);
                const data = getData(node);
                createInputFieldModal(editor, command, data);
            }
        }],
        buttonAction: (command:string) => {
            createInputFieldModal(editor, command, {solution: '', points: '', id: 0});
        },
        commandAction: (data:InputFieldData) => {
            insertInputField(data, editor);
        }    
    }
    const feature = new FeatureClass(config);
    feature.addToEditor(editor);
}


// export function addInputField(editor){
//     addInputFieldButton(editor);
//     addInputFieldCommand(editor);
//     addInputFieldMenuItem(editor);
//     addInputFieldContextMenu(editor);
// }



interface InputFieldData {
    id: number,
    solution: string | '';
    points: string | '0';
    width: number | 74;
    type: string | "if";
}

interface BuildInputFieldData {
    id: number,
    solution: string | '';
    points: string | '0';
}


const createInputFieldModal = (editor:Editor, command:string, data:BuildInputFieldData): void => {
    
    const modalId = 'create-input-field'
    const value = data.solution
    const content = '<p>Hier kannst du ein Eingabefeld einfügen, das exakt überprüft wird</p>\n' +
    '          <div class="d-flex justify-content-center">\n' +
    '               <input type="text" id="if-solution" placeholder="Lösung" value="'+value+'" class="form-control form-control-lg w-50 check-field">\n' +
    '          </div>';
    const settings = {
        leftInput: {
            placeholder: "Punkte",
            text: "Punkte",
            type: "text",
            value: data.points,
        },
        submitBtn: {
            text: 'Einfügen',
            class: 'add-input-field',
        },
        id: data.id,
        faq: 15,
    }
    const onclick = function(modal){
        const data = getDataFromModal(modal);
        if (data){
            return insertData(data, editor, command, modalId)
        }
    }
    const modal = makeEditorModal(modalId, 'Eingabefeld erstellen', content, settings, onclick);
    $("#if-solution").focus();
}



function getDataFromModal(modal){
    const errors = [];

    const solution = modal.find("#if-solution").val();
    const points = modal.find(".left-input").val();
    const id = getModalInputId(modal);
    if (!pointsValid(points) ){
        errors.push("Die Eingabe braucht eine gültige Punktzahl");
    }
    if (solution == ''){
        errors.push('Die Eingabe braucht eine gültige, nicht leere, Musterlösung');
    }

    if (errors.length == 0){
        return {
            solution: solution,
            points: points,
            id: id,
        }
    } else {
        displayErrors(errors);
        return false;
    }
}

function insertInputField(data:InputFieldData, editor:Editor){

    const html = transformInputFieldForInsert(data);    

    insertToEditor(html, editor);
    // Das ist ein HOTFIX! ACHTUNG
    // if (window["node"]){
    //     let json = toJsonHtml(data);
    //     $(window["node"]).attr('data-json', json);
    //     $(window["node"]).find("input#if").css("width", data.width +'px');
    //     $(window["node"]).find("input#if").attr('value', data.solution)
    // } else {
    //     insertToEditor(html, editor);
    // }
}

export function transformInputFieldForInsert(data:InputFieldData):string {
    let w = 74;
    const losungLength = data.solution.toString().length;
    if (losungLength > 5){
        w += (losungLength - 5) * 13;
    }
    data.width = w;
    data.type = "if";
    const json = JSON.stringify(data).replace( /(["])/g, "'");
    const html = '<span id="if" class="input-item mceNonEditable d-inline-block" data-json="'+json+'">' +
    '<input id="if" style="width: ' + w + 'px;" class="boxen form-control" type="text" value="'+data.solution+'" disabled>' + 
    '</span>';
    return html;
}


export function transformIf(data:InputFieldData, ind:number):inputTransformation{
    const html = '<input data-id="' + data.id + '" data-type="' + data.type + '" style="width: ' + data.width + 'px;" class="boxen form-control input" type="text" name="' + data.id + '_' + ind + '">';
    return {
        solution: {
            type: data.type,
            id: data.id,
            correct: data.solution.replace(/,/g, '.'), // TODO: CHECK
            points: data.points.replace(/,/g, '.'),
        },
        html: html
    }
}



